import { render } from "./Subscription.vue?vue&type=template&id=5fbff3c0&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=5fbff3c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbff3c0"]])

export default __exports__